import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPolicyHolderInfo, loadingUser } from "../action";
import "../styles/theme.scss";
import { useTranslation } from "react-i18next";
import { Button, Grid, Typography, Input } from "@mui/material";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import UploadIcon from "@mui/icons-material/Upload";
import * as XLSX from "xlsx";
import AddInsureeDialog from "./dialog/AddInsureeDialog";
import { apiHeaders } from "../utils/helper";
import InsureeTable from "./InsureeTable";
import InsureeFIlter from "./InsureeFIlter";

function PolicyHolderInsureeTab() {
  const SignInSuccess = useSelector((state) => state);
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [insureeCheck, setInsureeCheck] = useState(false);
  const [currentUser, setCurrentUSer] = useState();
  const [showDialog, setShowDialog] = useState(false);
  const [policyHolderId, setPolicyHolderId] = useState();
  const [insureeData, setInsureeData] = useState();
  const [filter, setFilter] = useState(false);
  const handleDownload = () => {
    const data = [
      [
        "Numéro CAMU",
        "Nom",
        "Prénom",
        "Numéro CAMU temporaire",
        "Date de naissance",
        "Lieu de naissance",
        "Sexe",
        "Civilité",
        "Téléphone",
        "Adresse",
        "Village",
        "ID Famille",
        "Email",
        "Matricule",
        "Salaire Brut",
        "Part Patronale %",
        "Part Patronale",
        "Part Salariale %",
        "Part Salariale",
        "Cotisation total",
        "Supprimé",
      ],
      [
        "",
        "Test",
        "Test",
        "",
        "03/03/2007",
        "Brazzaville",
        "M",
        "Célibataire",
        "242060000000",
        "Address",
        "CG105",
        "",
        "",
        "",
        "70000",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
    ];

    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet(data);

    // Create a workbook and add the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate a data URI containing the Excel data
    const dataURI = XLSX.write(wb, { bookType: "xlsx", type: "base64" });

    // Create a download link
    const link = document.createElement("a");
    link.href =
      "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
      dataURI;
    // link.download = this.userlang === "fr" ? "Echantillon_données_assurés.xlsx" : "sample_insurees_data.xlsx";
    link.download = "Echantillon_données_assurés.xlsx";
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleInsureeDownload = async () => {
    // const { policyHolder } = this.props;

    let encodedCode = encodeURIComponent(policyHolderId.code);
    let url_import = `${process.env.REACT_APP_BACKEND_URL}/api/policyholder/export/${encodedCode}/policyholderinsurees`;

    try {
      const response = await fetch(url_import, {
        headers: apiHeaders,
        method: "GET",
        credentials: "same-origin",
      });

      if (response.status >= 400) {
        return;
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // a.download = this.userlang === "fr" ? "liste des assurées Ouvrant droit.xlsx" : "policyholder_insurees.xlsx";
      a.download = "liste des assurées Ouvrant droit.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setInsureeCheck(true);
    } catch (error) {
      alert(
        error?.message ??
          `An error occurred. Please contact your administrator. ${error?.message}`
      );
    }
  };
  const onUpload = async (event) => {
    const file = event?.target?.files[0];
    let formData = new FormData();
    formData.append("file", file);
    let encodedCode = encodeURIComponent(policyHolderId.code);

    let url_import = `${process.env.REACT_APP_BACKEND_URL}/api/policyholder/imports/${encodedCode}/policyholderinsurees`;

    try {
      // Replace this with your actual token
      const apiHeaders = {
        Authorization: `Bearer ${token}`,
      };

      const response = await fetch(url_import, {
        headers: apiHeaders,
        body: formData,
        method: "POST",
        credentials: "same-origin",
      });

      if (response.status >= 400) {
        alert(`Error ${response.status}`);
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "liste des assurées Ouvrant droit.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setInsureeCheck(true);
    } catch (error) {
      alert(
        error?.message ??
          `An error occurred. Please contact your administrator. ${error?.message}`
      );
    }
  };
  useEffect(() => {
    dispatch(loadingUser(token));
  }, []);
  useEffect(() => {
    if (SignInSuccess?.profileReducer?.currentUserResponseData) {
      setCurrentUSer(SignInSuccess?.profileReducer?.currentUserResponseData);
    }
  }, [SignInSuccess]);
  useEffect(() => {
    if (currentUser?.id) {
      dispatch(fetchPolicyHolderInfo(currentUser?.id));
    }
  }, [currentUser]);
  useEffect(() => {
    if (SignInSuccess?.profileReducer?.policyholderUserResponseData) {
      setPolicyHolderId(
        SignInSuccess?.profileReducer?.policyholderUserResponseData?.[0]
          .policyHolder
      );
    }
  }, [policyHolderId, SignInSuccess]);
  return (
    <Grid container>
      <Grid container display="flex" justifyContent="space-between">
        <Typography
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#000",
            marginLeft: "20px",
          }}
        >
          {" "}
          {t("Add Insurees")}
        </Typography>
        <Grid style={{ marginRight: "20px" }}>
          <Button
            onClick={handleDownload}
            variant="outlined"
            component="span"
            color="primary"
            startIcon={<SaveAltRoundedIcon />}
            style={{ marginLeft: ".5rem" }}
          >
            {t("DownLoad Sample")}
          </Button>
          <Button
            onClick={handleInsureeDownload}
            color="primary"
            component="span"
            variant="outlined"
            startIcon={<SaveAltRoundedIcon />}
            style={{ marginLeft: ".5rem" }}
          >
            {t("DownLoad Inurees")}
          </Button>
          <Input
            required
            id="import-button"
            style={{ display: "none" }}
            inputProps={{
              accept:
                ".xls, application/vnd.ms-excel, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }}
            type="file"
            onChange={onUpload}
          />
          <label htmlFor="import-button">
            <Button
              component="span"
              color="primary"
              variant="outlined"
              startIcon={<UploadIcon />}
              style={{ marginLeft: ".5rem" }}
            >
              {t("Upload Inurees")}
            </Button>
          </label>
        </Grid>
      </Grid>
      {insureeData && (
        <InsureeFIlter
          policyHolderId={policyHolderId}
          setFilter={setFilter}
          filter={filter}
        />
      )}
      <InsureeTable
        policyHolderId={policyHolderId}
        filter={filter}
        setInsureeData={setInsureeData}
        insureeCheck={insureeCheck}
      />
      {showDialog && (
        <AddInsureeDialog
          showDialog={showDialog}
          setShowDialog={setShowDialog}
        />
      )}
    </Grid>
  );
}

export default PolicyHolderInsureeTab;
